import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { PackagingTypeDefinition } from '../../../models/packaging-type-definition';
import { Observable } from 'rxjs';
import {
    selectCourierDetails,
    selectCourierOptions,
    selectPackagingTypes
} from '../../../store/profile/profile.state';
import { CourierOptionDefinition } from '../../../models/courier-option-definition';
import { CourierDetail } from '../../../models/courier-detail';
import { map } from 'rxjs/operators';
import { CourierService } from '../../../models/courier-service';

@Injectable({
    providedIn: 'root'
})
export class CourierProfileService {

    packagingTypes$: Observable<PackagingTypeDefinition[]>;

    options$: Observable<CourierOptionDefinition[]>;

    courierDetails$: Observable<CourierDetail[]>;

    constructor(private store: Store<AppState>) {
        this.packagingTypes$ = this.store.select(selectPackagingTypes);
        this.options$ = this.store.select(selectCourierOptions);
        this.courierDetails$ = this.store.select(selectCourierDetails);
    }

    getCourierDetail(courierModule: string): Observable<CourierDetail> {
        return this.courierDetails$.pipe(
            map((details) => details.find((detail) => detail.code === courierModule)),
        );
    }

    getCourierName(courierModule: string): Observable<string> {
        return this.getCourierDetail(courierModule).pipe(
            map((detail) => detail.name)
        );
    }

    getServiceLabel(courierModule: string, serviceId: string): Observable<string> {
        return this.getCourierDetail(courierModule).pipe(
            map((courier) => courier.services),
            map((services) => services[Object.keys(services).find((service) => services[service].code === serviceId)]),
            map((service) => service.label)
        );
    }

    getAllServices(): Observable<CourierService[]> {
        return this.courierDetails$.pipe(
            map((details) => details.map(
                (detail) => Object.keys(detail.services)
                    .map(key => detail.services[key])
                    .map(service => ({
                        serviceId: service.code,
                        courierModule: detail.code,
                        serviceName: service.label,
                        courierName: detail.name
                    }))
            ).flat()),
        );
    }

}
